import PopupArticle from './popup-article.pug';
import Manager from '../../manager/manager';
import Popup from '../popup';

export default {
  props: {
    content: {
      type: Object,
      // default: () => {},
    },
    type: {
      type: String,
    },
  },
  template: PopupArticle(),
  delimiters: ['${', '}}'],
  components: {
    Manager,
  },
  data() {
    return {
      callbackModal: new Popup({
        popup: '#callback',
        type: 'new',
      }),
    };
  },
  methods: {
    closePopup() {
      this.$emit('close-article-popup');
      window.bodyLock.clearAllBodyScrollLocks();
    },
    openPopup() {
      this.closePopup();
      // this.$emit('callback-after-article');
      if (this.callbackModal) this.callbackModal.open();
    },
  },
  mounted() {
    if (this.callbackModal || this.type !== 'button') return;
    this.callbackModal = new Popup({
      popup: '#callback',
      type: 'new',
    });
  },
};



// WEBPACK FOOTER //
// ./blocks/popup/article/popup-article.js